<div class='delivery-accelerators-tab-2-part'>
	This is delivery-accelerators tab 2
</div>